import * as React from 'react';
import { OTPMFATestWidget } from '../OTPFactorTestWidget';
import { styled } from '../../../../../../theme';
import { useSystem } from '../../../../../../hooks/useSystem';
import { useMFAStore } from '../../../../../../hooks/useMFAStore';
import { SMSMFAModel } from '../../../../../../models/SMSMFAFactorModel';
import { ConfigureMFANavigationAction } from '../../ConfigureMFADialog';

export type SMSMFATestWidgetProps = {
  factorId: string;
  back: ConfigureMFANavigationAction;
  next: ConfigureMFANavigationAction;
  onCancel: ConfigureMFANavigationAction;
};

export const SMS_OTP_CODE_LENGTH = 6;

namespace S {
  const BASE_LABEL = 'sms-mfa-test-widget';

  export const MessageContainer = styled.div`
    margin: auto;
  `;

  export const Message = styled.div`
    label: ${BASE_LABEL}-message;
    font-size: 14px;
    color: ${(p) => p.theme.text.secondary};
    text-align: center;
  `;

  export const Resend = styled.span`
    font-weight: bold;
    cursor: pointer;
  `;
}

export const SMSMFATestWidget: React.FC<SMSMFATestWidgetProps> = (props) => {
  const system = useSystem();
  const mfaStore = useMFAStore();

  const factor = mfaStore.item(props.factorId) as SMSMFAModel;

  return (
    <OTPMFATestWidget
      otpLength={SMS_OTP_CODE_LENGTH}
      pendingValidationContent={() => (
        <S.MessageContainer>
          <S.Message>We've sent an SMS/text message to your phone. Please enter the code here.</S.Message>
          <S.Message>
            Didn't get it?{' '}
            <S.Resend
              onClick={async () => {
                try {
                  await factor.sendSMS();
                } catch (error) {
                  console.error(error);
                  system.dialogStore.errorDialog({
                    errorMessage:
                      'Could not send SMS/Text. Request are rate limited to 1 per minute. Please retry in a few minutes..'
                  });
                }
              }}
            >
              Resend SMS/Text message
            </S.Resend>
          </S.Message>
        </S.MessageContainer>
      )}
      {...props}
    />
  );
};
